import { ActiveStatus } from "models/enumerations/active-status/active-status";
import { AudienceType } from "models/enumerations/audiences/audience-type";
import { Language } from "models/enumerations/languages/language";
import { Topic } from "models/enumerations/courses/topic";
import { createContext, useContext } from "react";

export interface CourseSearchCriteria {
    searchText: string;
    audienceType?: AudienceType;
    language?: Language;
    topic?: Topic;
    status: ActiveStatus;
    currentPage: number;
}

export interface CourseSearchContextParams {
    initialCriteria: CourseSearchCriteria;
    setCriteria: React.Dispatch<React.SetStateAction<CourseSearchCriteria>>;
}

const defaultCourseSearchCriteria: CourseSearchCriteria = {
    searchText: "",
    audienceType: undefined,
    language: undefined,
    topic: undefined,
    status: ActiveStatus.Active,
    currentPage: 1,
};

const CourseSearchContext = createContext<CourseSearchContextParams>({
    initialCriteria: defaultCourseSearchCriteria,
    setCriteria: () => {},
});

const useCourseSearch = () => {
    return useContext(CourseSearchContext);
};

export { CourseSearchContext, useCourseSearch, defaultCourseSearchCriteria };
